import React from "react";
import { Box } from "@mui/material";

import { CustomLinearBarStyled } from "./custom-linear-bar.styles";
import { isSomething } from "../../../../../../utils/utils";

const CustomLinearBar = ({ data }) => {
  return (
    <CustomLinearBarStyled data={data}>
      {isSomething(data) && (
        <Box className="main-linear-wrapper">
          <Box className="green-linear-bar" />
          <Box className="red-linear-bar" />
          {data?.transparent ? (
            <Box className="transparent-linear-bar" />
          ) : (
            <></>
          )}
        </Box>
      )}
    </CustomLinearBarStyled>
  );
};

export default CustomLinearBar;
